@let vm = vm$();

<div class="vehicles-page flex-col gap-16 h-100 min-h-0 w-100 p-24">
  <div class="flex-row space-between-center header-container">
    <app-database-tabs
      [tabs]="vehiclePageTabs"
      [activeTab]="vm.currentTab"
      (activeTabChange)="onChangeActive($event)">
    </app-database-tabs>

    @if (vm.currentTab === 'existing' && vm.existing.viewState !== 'INITIAL_EMPTY' && vm.existing.viewState !== 'LOADING') {
      <div class="flex-row gap-8">
        <ui-button type="secondary" (click)="addCsv()">{{ 'VEHICLES.BUTTONS.ADD_FROM_FILE' | translate }}</ui-button>
        <ui-button type="primary" (click)="add()">{{ 'VEHICLES.BUTTONS.ADD_VEHICLE' | translate }}</ui-button>
      </div>
    }
  </div>

  <div class="content-area min-h-0 w-100">
    @switch (vm.currentTab) {
      @case ('existing') {
        @if (vm.existing.viewState !== 'LOADING' && vm.existing.viewState !== 'INITIAL_EMPTY') {
          <div class="flex-row space-between-start">
            <div class="flex-col search-bar mb-16 gap-16">
              <ui-search [placeholder]="'VEHICLES.PLACEHOLDERS.SEARCH_EXISTING' | translate" [searchQuery]="vm.searchQuery" (searchQueryChange)="searchQuery.set($event)"></ui-search>
            </div>
          </div>
        }
        @switch (vm.existing.viewState) {
          @case ('LOADING') { <ui-preloader [color]="PreloaderColor.blue"></ui-preloader> }
          @case ('INITIAL_EMPTY') { <ui-no-data [imgSrc]="noSaved.imgSrc" [title]="noSaved.title1 | translate" [createButtonText]="'VEHICLES.BUTTONS.ADD_VEHICLE' | translate" (onCreate)="add()" [secondaryButtonText]="'VEHICLES.BUTTONS.ADD_FROM_FILE' | translate" (onSecondary)="addCsv()"></ui-no-data> }
          @case ('NO_RESULTS') { <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title1 | translate"></ui-no-data> }
          @case ('HAS_DATA') { <app-vehicles-table #existingTable [vehicles]="vm.existing.vehicles"></app-vehicles-table> }
        }
      }
      @case ('unsaved') {
        @if (vm.unsaved.viewState !== 'LOADING' && vm.unsaved.viewState !== 'INITIAL_EMPTY') {
          <div class="flex-row space-between-start gap-16 mb-16">
            <div class="flex-col search-bar mb-16 gap-16">
              <ui-search [searchQuery]="vm.searchQuery" [placeholder]="'VEHICLES.PLACEHOLDERS.SEARCH_UNSAVED' | translate" (onInput)="searchQuery.set($event)"></ui-search>
            </div>
          </div>
        }
        @switch (vm.unsaved.viewState) {
          @case ('LOADING') { <ui-preloader [color]="PreloaderColor.blue"></ui-preloader> }
          @case ('INITIAL_EMPTY') { <ui-no-data [imgSrc]="noSaved.imgSrc" [title]="noSaved.title2 | translate" [secondaryButtonText]="'VEHICLES.BUTTONS.ADD_FROM_FILE' | translate" (onSecondary)="addCsv()"></ui-no-data> }
          @case ('NO_RESULTS') { <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title2 | translate"></ui-no-data> }
          @case ('HAS_DATA') { <app-unsaved-vehicles-table [unsavedVehicles]="vm.unsaved.vehicles"></app-unsaved-vehicles-table> }
        }
      }
    }

      @if (vm.existing.selectedRows.size > 0) {
          <ui-selected-items-snackbar
                  [counter]="vm.existing.selectedRows.size"
                  [selectedText]="'VEHICLES.VEHICLES_SELECTED'"
                  (selectAll)="selectAllDisplayedVehicles()"
                  (clearAll)="clearSelectedVehicles()"
          >
              @if (currentTab() === 'existing') {
                  <div class="flex-row gap-8">
                      <ui-button
                              [text]="'VEHICLES.ADD_TO_GROUP' | translate"
                              type="secondary"
                              (clickAction)="openAddVehicleToGroupsDialog()"
                      ></ui-button>
                      <ui-button
                              [text]="'COMMON.DELETE' | translate"
                              type="secondary"
                              (clickAction)="removeSelectedExisting(vm.existing.selectedRows)"
                      ></ui-button>
                  </div>
              } @else {
                  <ui-button
                          [text]="'VEHICLES.SAVE_VEHICLE' | translate"
                          type="secondary"
                  ></ui-button>
              }
          </ui-selected-items-snackbar>
      }
  </div>
</div>
